var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymSoppel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.998,
    cy: 2.75,
    r: 2.5,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M6.07837,7 L5.00171,19.917 L6.99487,20.083 L7,20.02148 L7,32 L9,32 L9,19 L11,19 L11,32 L13,32 L13,19 L14,19 L14.91852,19.00063 L14.19171,10.281 L19.14948,15.74968 L20.63123,14.40642 L13.91833,7.00182 L13,7 L13,7 L6.07837,7 Z M7.25171,17 L7.91821,9 L12.07837,9 L12.74487,17 L7.25171,17 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    fillRule: "nonzero",
    points: "27.563 18.994 25.502 19 24.241 30.003 19.793 30.003 18.531 18.994 16.471 19.003 18.009 32 19.195 32 20.022 32 24.341 32 24.341 31.991 26.025 31.991"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20,
    r: 1,
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 22,
    y: 22,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 21,
    y: 27,
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymSoppel);
export default __webpack_public_path__ + "static/media/BYM_Soppel.91568c18.svg";
export { ForwardRef as ReactComponent };